import script from "./dol-list.vue?vue&type=script&lang=js"
export * from "./dol-list.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__